import channelTypes from './channelTypes';

export default {
  activeChannels(state) {
    return state.channels.filter(channel => channel.live);
  },

  channels(state) {
    return state.channels;
  },

  channelIcons() {
    return {
      0: { color: 'sms', icon: 'fa-mobile' },
      1: { color: 'email', icon: 'fa-envelope' },
      2: { color: 'twitter', icon: 'fa-twitter' },
      3: { color: 'facebook', icon: 'fa-facebook' },
      4: { color: 'gplus', icon: 'fa-google-plus' },
      6: { color: 'wechat', icon: 'fa-wechat' },
      7: { color: 'webhook', icon: 'fa-globe' },
      8: { color: 'ussd', icon: 'fa-call' },
      9: { color: 'whatsapp', icon: 'fa-whatsapp' },
      10: { color: 'instagram', icon: 'fa-instagram' },
      11: { color: 'cellfind', icon: 'fa-mobile' },
    };
  },

  inactiveChannels(state) {
    return state.channels.filter(channel => !channel.live);
  },

  /**
   * Get activechannels and return only social channels
   * @param {*} state
   * @param {*} getters
   */
  socialChannels(state, getters) {
    return getters.activeChannels.filter(
      x =>
        [channelTypes.FACEBOOK, channelTypes.TWITTER, channelTypes.TIKTOK].indexOf(
          x.channel_type,
        ) !== -1,
    );
  },

  facebookChannels(state, getters) {
    return getters.activeChannels.filter(x => x.channel_type === channelTypes.FACEBOOK);
  },

  instagramChannels(state, getters) {
    return getters.activeChannels.filter(x => x.channel_type === channelTypes.INSTAGRAM);
  },

  twitterChannels(state, getters) {
    return getters.activeChannels.filter(x => x.channel_type === channelTypes.TWITTER);
  },

  tiktokChannels(state, getters) {
    return getters.activeChannels.filter(x => x.channel_type === channelTypes.TIKTOK);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/channel/getters.js